import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError, notificationSucces } from "./notification";
import { IConfigApiReturn } from "../pages/ConfigPages/types";
import { createQueryParams } from "../utils/stringUtils";


export async function getConfig() {
  let res: IConfigApiReturn = {
    timezones: [],
    bingo_fee: [],
    configs:[],
  }

  await Api.get(endpoints.getConfigsList).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        res = response.data
      }
    } else {
      notificationError('Could not get system configuration')
    }
  }).catch((err: string) => {
    notificationError('Could not get system configuration')
  })

  return res
}

export async function updatePortalConfigurations(payload: any) {

  await Api.post(endpoints.saveConfigList, payload, {

  }).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Configuration saved')
      }
    } else {
      notificationError('Could not save configuration')
    }
  }).catch((err: string) => {
    notificationError('Could not save configuration')
  })

}

export async function saveConfigImages(file: any) : Promise<boolean> {
  let formData = new FormData()
  let res : boolean = false
  formData.append('file', file)
  await Api.post('/manufacturerconfig/save_image?key=IMAGE_OF_THE_DAY_FILE', formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.error}`)
        res = false
      } else {
        notificationSucces('Image saved')
        res = true
      }
    } else {
      notificationError('Could not save image')
      res = false
    }
  }).catch((err: string) => {
    notificationError('Could not save image')
    res = false
  })
  return res
}

export async function saveWelcomeImages(file: any, params: object) {
  let formData = new FormData()
  const queryParam = createQueryParams(params)
  formData.append('file', file)
  await Api.post('/manufacturerconfig/save_image?'+queryParam, formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Image saved')
      }
    } else {
      notificationError('Could not save image')
    }
  }).catch((err: string) => {
    notificationError('Could not save image')
  })
}

export async function getConfigImages(params: any) {
  let res: any = null
  await Api.get('/manufacturerconfig/show_image', {params, responseType: 'blob'}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        const objectUrl = URL.createObjectURL(response.data)
        res = objectUrl
      }
    } else {
      notificationError('Could not get image')
    }
  }).catch((err: string) => {
    notificationError('Could not get image')
  })
  return res
}
export async function createFee(params: any) {

  await Api.post(endpoints.createFee, params).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Bingo Fee created')
      }
    } else {
      notificationError('Could not create bingo fee')
    }
  }).catch((err: string) => {
    notificationError('Could not create bingo fee')
  })
}

export async function deleteFee(params: any) {

  await Api.get(endpoints.deleteFee, {params}).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Bingo Fee deleted')
      }
    } else {
      notificationError('Could not delete bingo fee')
    }
  }).catch((err: string) => {
    notificationError('Could not delete bingo fee')
  })
}

export async function refreshCompanyCache() {

  await Api.get(endpoints.refreshCompanyCache).then((response) => {
    if (response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Company cache reloaded successfully!')
      }
    } else {
      notificationError('Could not reload company cache')
    }
  }).catch((err: string) => {
    notificationError('Could not reload company cache')
  })
}

